module.exports = __webpack_public_path__ + "img/profile-image.3a7bb766.png";